import { bootstrapAppSaga } from './bootstrap';
import { appUpdateSagas } from './update';
import { all, takeLatest } from 'redux-saga/effects';

export function* appSagas() {
    yield all([takeLatest('bootstrap::begin', bootstrapAppSaga), appUpdateSagas()]);
}
